<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Insurance.LiabilityInsuranceInquiry')"
    append-to-body
    :fullscreen="true"
    :close-on-click-modal="false"
    :before-close="handleClose"
    class="inquiry-class"
  >
    <div style="background: grey;padding: 1px;flex-grow: 1;height:100%;">
      <div style="margin-left: 20%;padding-left: 15%; width: 60%;background: white;height:100%;overflow-y: auto">
        <el-form :model="form" style="padding-top: 1px">
          <p style="color: red;margin-top: 5px">{{ $t('Insurance.InquiryForQuestionnaireContent') }}</p>
          <p>{{ $t('Insurance.AfterFillingQuestionnaire') }}</p>
          <h4>{{ '1、' + $t('Insurance.ServiceProviderSelection') }}</h4>
          <el-form-item :label="$t('SystemMaintenance.ServiceProviders')" label-width="150px" style="width: 520px" required>
            <cargo-advance-select
              :static-options="insuranceAgentList"
              tag-value="code"
              filterable
              :disabled="!!form.uuid"
              filter-type="global"
              :cache="false"
              :clearable="false"
              :default-value="form.insuranceAgent"
              @parentCallBack="p=>{form.insuranceAgent=p.value}"
            />
          </el-form-item>
          <h4>{{ '2、' + $t('Insurance.ApplicantInformation') }}</h4>
          <el-form-item :label="$t('CargoMsg.Cargo_Contact')" label-width="150px" style="width: 520px" required>
            <cargo-user-select
              :method-params="{officeId:form.branchId,active:true}"
              :default-value="form.contactUser ||''"
              :clearable="false"
              @change="p=>changeConcatUser(p)"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_ContactNumber')" label-width="150px" style="width: 520px" required>
            <el-input v-model="form.contactTel" />
          </el-form-item>
          <el-form-item :label="$t('Partners.emailAddress2')" label-width="150px" style="width: 520px">
            <el-input v-model="form.contactAddress" />
          </el-form-item>
          <h4>{{ '3、' + $t('Insurance.RegisteredAndBusiness') }}</h4>
          <el-form-item :label="$t('Insurance.RegisteredName')" label-width="150px" style="width: 520px" required>
            <cargo-office-select
              :office-id="Number(form.registeredIdx || 0)"
              :clearable="false"
              @change="p=>changeRegisteredIdx(p)"
            />
          </el-form-item>
          <el-form-item :label="$t('Insurance.RegisteredAddress')" label-width="150px" style="width: 520px" required>
            <el-input v-model="form.registeredAddress" style="width: 370px" />
          </el-form-item>
          <el-form-item :label="$t('Insurance.BusinessName')" label-width="150px" style="width: 520px">
            <el-input v-model="form.businessName" style="width: 370px" />
          </el-form-item>
          <el-form-item :label="$t('Insurance.BusinessAddress')" label-width="150px" style="width: 520px">
            <el-input v-model="form.businessAddress" style="width: 370px" />
          </el-form-item>
          <h4>{{ '4、' + $t('Insurance.InquiryQuestionnaire') }}</h4>
          <div style="margin-left: 10px; width: 520px">
            <el-upload
              action
              multiple
              accept=".doc, .docx, .pdf"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="toChooseFile"
              style="float:left;margin-right:10px"
            >
              <el-button type="primary">{{ $t('SeaExport.SelectFile') }}</el-button>
            </el-upload>
            <el-button type="primary" @click="downloadTemplate">{{ $t('SeaExport.DownloadTemplate') }}</el-button>
            <el-table :data="fileList" border style="width: 100%;margin-top: 5px">
              <el-table-column prop="dateCreated" :label="$t('SeaExport.SubmissionDateTime')" />
              <el-table-column :label="$t('Message.File')">
                <template slot-scope="scope">
                  <i style="color: #0A0AFF" @click="downloadFile(scope.row)">{{ scope.row.fileName }}</i>
                </template>
              </el-table-column>
              <el-table-column :label="$t('SeaExport.Operation')" width="50px">
                <template slot-scope="scope">
                  <i class="el-icon-delete" @click="removeFile(scope.row)" />
                </template>
              </el-table-column>
            </el-table>
          </div>
          <h4>{{ '5、' + $t('Insurance.ServiceProviderReply') }}</h4>
          <div style="margin-left: 10px">
            <el-steps v-for="(item) in replyList" :key="item.replyTime" direction="vertical" :active="replyList.length">
              <el-step icon="''">
                <div slot="title"><span>{{ $t('Insurance.RecoveryTime') + item.replyTime }}</span></div>
                <div slot="title"><span>{{ $t('Insurance.ReplyContent') + item.content }}</span></div>
              </el-step>
            </el-steps>
          </div>
          <h4>{{ '6、' + $t('SeaExport.Remarks') }}</h4>
          <el-input v-model="form.remarks" type="textarea" :autosize="{ minRows: 4}" style="width: 520px;margin-left: 10px" />
        </el-form>
      </div>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="saveInquiry">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button @click="handleClose">{{ $t('SeaExport.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

import cargoUpDownResize from '@/components/Cargo/Common/cargoUpDownResize'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import * as InsuranceConstants from '@/class/cargo/model/parameters/InsuranceConstants'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { InsureInfo } from '@/class/model/booking/InsureInfo'
import { getLoading } from '@/utils/utilBaseElement'
import { liabilityInsurance, uploadInquiryFile } from '@/api/external/insureInfo'
import { getToken } from '@/utils/auth'
import CargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload'
import { AutoIncrementNum } from '@/utils/commonUtil'
import { getBusinessDocumentList } from '@/api/businessDocument'
import { cache, cacheName } from '@/utils/cacheManager'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import URL from '@/api/urlTranslator'

export default {
  name: 'Inquiry',
  components: {
    CargoCloudFileUpload,
    CargoUserSelect,
    CargoButtonGroupSlider,
    cargoUpDownResize,
    cargoAdvanceSelect,
    cargoOfficeSelect
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      sessionId: getToken(),
      innerVisible: false,
      form: new InsureInfo().fillDefaultValue().getData(),
      insuranceAgentList: InsuranceConstants.INQUIRY_INSURANCE_AGENT,
      selectTypeNames: TYPE_NAMES,
      fileList: [], // 文件列表
      replyList: [], // 供应商回复列表
      autoIncrementNum: new AutoIncrementNum(),
      storageURL: '',
      curTimeSecond: 0
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.$emit('close')
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.storageURL = cache.config.get('StorageURL')
    // this.openInsure('')
  },
  methods: {
    async onShow(row) {
      this.form = row
      if (this.form.supplierResponse) {
        this.replyList = JSON.parse(this.form.supplierResponse)
      }
      if (this.form.uuid) {
        await getBusinessDocumentList({ documentCategory: this.documentCategory, businessId: this.form.uuid }).then(res => {
          this.fileList = res.data
        })
      } else {
        // CARGO-39082 打开责任险询价新增页面则创建一个未提交的询价记录
        const loading = getLoading()
        this.form.branchId = this.$store.getters.currentOfficeId
        await liabilityInsurance(this.form).then(async res => {
          if (res.ok) {
            this.form = res.data
          }
        }).finally(() => {
          loading.close()
        })
      }
    },
    // 打开询价页面加载
    // async openInsure(agent = '') {
    //   this.form = new InsureInfo().fillDefaultValue().getData()
    //   const office = this.$store.getters.currentOffice
    //   this.form.registeredIdx = office.officeId
    //   this.form.registeredName = office.chineseName
    //   this.form.registeredAddress = office.chineseAddress
    //   this.form.insuranceAgent = 'htjj'
    //   const userInfo = this.$store.getters.userInfo
    //   this.form.contactUser = userInfo.userId
    //   this.form.contactTel = userInfo.userPhone
    //   this.form.contactAddress = userInfo.email
    //   if (agent) {
    //     this.form.insuranceAgent = agent
    //   }
    // },
    // 保存询价
    async saveInquiry() {
      const loading = getLoading()
      // 问卷状态 0未提交 1已提交 2已接收 若该问卷不是已接收状态，在保存时自动置为已提交状态
      if (this.form.questionnaireStatus !== 2) {
        this.form.questionnaireStatus = 1
      }
      this.form.branchId = this.$store.getters.currentOfficeId
      await liabilityInsurance(this.form).then(async res => {
        if (res.ok) {
          this.form = res.data
          // 上传文件并且记录到文档管理中
          for (const item of this.fileList) {
            if (!item.uuid) {
              const payload = { branchId: this.form.branchId, afUuid: this.form.uuid, file: item.file }
              await uploadInquiryFile(payload)
            }
          }
          this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
          this.handleClose()
          this.$emit('showGridPage', this.form.insuranceAgent)
        }
      }).finally(() => {
        loading.close()
      })
    },
    downloadTemplate() {
      // 根据对应代理下载对应模板
      let fileName = ''
      switch (this.form.insuranceAgent) {
        case 'xnhb':
          fileName = '货代责任险问卷调查.docx'
          break
        case 'htjj':
          fileName = '货运代理责任保险调查问卷.docx'
          break
        case 'lhb':
          fileName = '货代责任险《调查问卷》2023.docx'
          break
      }
      if (fileName) {
        const folderName = 'booking'
        ExportUtils.downloadTemplateFile(fileName, folderName)
      } else {
        this.$message.warning(this.$t('Insurance.NoCorrespondingTemplate'))
      }
    },
    downloadFile(data) {
      if (data.documentId) {
        window.open(`${URL.common.findByFileId}/${data.documentId}?sessionId=${this.sessionId}`)
      }
    },
    removeFile(data) {
      const fileList = []
      for (const item of this.fileList) {
        if (item.fileName !== data.fileName) {
          fileList.push(item)
        } else {
          if (item.uuid) {
            this.$message.warning(this.$t('Insurance.UploadedFileUnRemove'))
            return
          }
        }
      }
      this.fileList = fileList
    },
    handleClose() {
      this.innerVisible = false
      this.fileList = []
      this.replyList = []
    },
    // 切换注册名称
    async changeRegisteredIdx(data) {
      this.form.registeredIdx = data.officeId
      this.form.registeredName = data.chineseName
      this.form.registeredAddress = data.chineseAddress
    },
    // 切换联系人
    async changeConcatUser(data) {
      this.form.contactUser = data.userId
      this.form.contactTel = data.phone
      this.form.contactAddress = data.email
    },
    async toChooseFile(file, fileList) {
      const now = new Date().getTime()
      if (file.size > 20 * 1024 * 1024) {
        if (now - this.curTimeSecond > 100) {
          this.curTimeSecond = now
          await this.$message.warning(this.$t('Message.N1Exceeds20MBCannotUploaded'))
        }
        return
      }
      const fileName = file.name
      const fileType = fileName.substr(fileName.lastIndexOf('.') + 1)
      if ((!fileType || !(fileType === 'doc' || fileType === 'docx' || fileType === 'pdf'))) {
        if (now - this.curTimeSecond > 100) {
          this.curTimeSecond = now
          await this.$message.warning(this.$t('Insurance.OnlyFileDocAndPdf'))
        }
        return
      }
      this.fileList.push({
        seq: this.autoIncrementNum.getNextNum(),
        fileId: '',
        fileName,
        fileType,
        fileSize: file.size,
        fileCategory: '',
        fileCategoryLabel: '',
        file: file.raw
      })
    }
  }
}
</script>

<style lang="scss">
.inquiry-class {
  .el-dialog.is-fullscreen {
    display: flex;
    flex-direction: column;
    .el-dialog__body {
      flex-grow: 1;
      overflow: auto;
    }
  }
}
</style>>
